import React from 'react';
import styles from './ComparisonTable.module.css';

const ComparisonTable = ({ features, columns }) => {
  const renderValue = (value) => {
    if (value === true) {
      return (
        <span className={styles.table__check}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" fill="black" />
            <path d="M17 8L10 15L7 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </span>
      );
    }
    if (value === false) {
      return <span className={styles.table__dash}>&mdash;</span>;
    }
    return <span className={styles.table__text}>{value}</span>;
  };

  // Flatten all items from all sections into a single list
  const allItems = features.flatMap((section) => section.items);

  return (
    <div className={styles.table__wrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={`${styles.table__header} ${styles['table__header--empty']}`}></th>
            {columns.map((col) => (
              <th key={col} className={styles.table__header}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr className={styles.table__categoryRow}>
            <td colSpan={columns.length + 1} className={styles.table__category}>
              Core Features
            </td>
          </tr>
          {allItems.map((item) => (
            <tr key={item.name} className={styles.table__row}>
              <td className={styles.table__featureName}>{item.name}</td>
              {item.values.slice(item.values.length - columns.length).map((value, i) => (
                <td key={i} className={styles.table__value}>
                  {renderValue(value)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ComparisonTable;
